import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import styles from './input-radio.scss';

const InputRadio = ({ text, tabIndex, ...props }) => (
  <label className={styles.label}>
    <input className={styles.radio} type="radio" {...props}/>
    <span className={classNames(styles.fakeRadio, 'button-border-color')} data-hook="input-radio"/>
    <span className={classNames(styles.fakeRadioChecked, 'button-border-color')}>
      <span className={classNames(styles.innerCircle, 'button-background-color')}/>
    </span>
    <span className={styles.text} role="radio" aria-checked={props.checked} tabIndex={tabIndex}>
      {text}
    </span>
  </label>
);

InputRadio.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  text: PropTypes.node,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  tabIndex: PropTypes.string.isRequired,
};

export default InputRadio;



// WEBPACK FOOTER //
// ./app/components/input-radio/input-radio.js